.cardStylesHoliday {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  min-width: 100%;
}

.formBackground {
  background-color: #ffffff;
}

.tableWrapper {
  padding: 0.3rem;
  overflow: hidden;
}

.tableHead {
  background-color: #dcdcdc;
}
.tableRow, .notFoundContainer {
  background-color: #f5f5f5;
}

.holiday_table td {
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal !important;
  text-align: justify;
}

.tableHeadCell {
  padding: 1rem 1.4rem;
  letter-spacing: 0.05em;
}

.tableHr {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}

.tableHeadCellDate {
  width: 20%;
  text-align: left;
}
.tableHeadCellNotes {
  width: 35%;
  text-align: left;
}
.tableHeadCellComments {
  width: 35%;
  text-align: left;
}

.tableHeadCellStatus {
  width: 10%;
  text-align: center;
  white-space: nowrap;
  padding-right: 1rem!important;
}

.tableRowCellStatus {
  text-align: right;
  white-space: nowrap;
}

.tableRowCellStatus span {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  text-transform: capitalize;
}

.statusText {
  padding: 0.5rem;
}
.statusTextApproved {
  background-color: #D1FAE5;
}
.statusTextPending {
  background-color: #fac58e;
}
.statusTextRejected {
  background-color: #faa2a2;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pageButton {
  border: none;
  margin-right: 0.5rem;
  background-color: transparent;
  color: #333;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  transition: color 0.2s ease-in-out;
}

.pageButton:hover,
.pageButton:focus {
  color: #007bff;
}

.active {
  color: #007bff;
  font-weight: bold;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.ellipsis {
  margin: 0 5px;
  font-size: 1.2em;
  font-weight: bold;
}

.itemsPerPage {
  margin: 1rem 0;
  font-size: 1.2rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.paginationLabel {
  font-weight: bold;
  margin-right: 0.5rem;
  font-size: 0.9rem;
  margin-bottom: unset;
}

.select {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  font-size: 1rem;
}

.textNotice {
  font-size: 90%;
  white-space: pre-wrap;
  padding: 0.75rem;
}

.notFoundContainer {
  padding: 0.3rem;
}

@media (max-width: 768px) {
  .pagination {
    flex-wrap: wrap;
  }

  .itemsPerPage {
    margin-bottom: 1rem;
    justify-content: center;
  }

  .paginationLabel {
    margin-right: 0.2rem;
  }

  .select {
    font-size: 0.9rem;
    margin-left: 0.5rem;
  }

  .pageButton {
    font-size: 0.9rem;
    margin: 0.2rem;
    padding: 0.3rem;
  }

  .ellipsis {
    display: none;
  }
}
